export default function transleetSessionFormat(name) {

    if(!name) return "Не установлено"
    return name === "CAMPAIGN" ? "Кампейн" : name === "ONESHOT" ? "Ваншот" : name
}